import React from "react";

export default class Exchange extends React.Component {
  constructor(props) {
    super(props);
    this.page = this.props.match.params.id;
    this.nextPage =
      this.props.match.params.id < 3
        ? parseInt(this.props.match.params.id) + 1
        : false;
  }
  getStyles() {
    return {
      marginTop: "-48px",
      transform: "translateX(-50%)",
      position: "absolute",
      left: "50%"
    };
  }
  render() {
    return (
      <div>
        <a href={this.nextPage}>
          <img
            style={this.getStyles()}
            src={`/aot-exchange/${this.page}.png`}
          />
        </a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/AOT/Exchange.js